/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Organisation } from "./Organisation";
import {
  OrganisationFromJSON,
  OrganisationFromJSONTyped,
  OrganisationToJSON,
  OrganisationToJSONTyped,
} from "./Organisation";

/**
 *
 * @export
 * @interface PaginatedOrganisationList
 */
export interface PaginatedOrganisationList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<Organisation>;
}

/**
 * Check if a given object implements the PaginatedOrganisationList interface.
 */
export function instanceOfPaginatedOrganisationList(
  value: object
): value is PaginatedOrganisationList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedOrganisationListFromJSON(json: any): PaginatedOrganisationList {
  return PaginatedOrganisationListFromJSONTyped(json, false);
}

export function PaginatedOrganisationListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedOrganisationList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(OrganisationFromJSON),
  };
}

export function PaginatedOrganisationListToJSON(json: any): PaginatedOrganisationList {
  return PaginatedOrganisationListToJSONTyped(json, false);
}

export function PaginatedOrganisationListToJSONTyped(
  value?: PaginatedOrganisationList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(OrganisationToJSON),
  };
}
